import { createContext, useContext } from 'react';

import { CurrentUserDetailsResponseDto } from '@/api/generated';

const UserDefaultValues: UserContextProps = {
  email: '',
  enabled: true,
  firstName: '',
  lastName: '',
  permissions: [],
  rolePermissions: {},
  roles: [],
  userId: '',
};

export type UserContextProps = CurrentUserDetailsResponseDto;
export const UserContext = createContext<UserContextProps>(UserDefaultValues);

export const useUserContext = (): UserContextProps => {
  return useContext(UserContext);
};
